import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setAccountPreferences } from 'features/auth/authSlice'
import { getPreferences } from 'features/settings/settingSlice'
import i18n from './index'
import { applyLanguage, getAccountLanguage } from './appLanguage'

export default function LanguageSync() {
  const dispatch = useDispatch()
  const account = useSelector((state) => state.auth.user)
  const accountId = account?._id
  const token = account?.token

  useEffect(() => {
    if (!accountId || !token) return undefined

    let cancelled = false
    const restoredLanguage = getAccountLanguage(account)

    if (restoredLanguage) {
      applyLanguage(restoredLanguage, i18n)
    }

    dispatch(getPreferences())
      .unwrap()
      .then((response) => {
        if (cancelled) return
        const language = getAccountLanguage(response)
        if (!language) return

        return applyLanguage(language, i18n).then(() => {
          if (!cancelled) dispatch(setAccountPreferences(response.preferences))
        })
      })
      .catch(() => {})

    return () => {
      cancelled = true
    }
    // Account identity/token changes on both User and Church login. Preferences
    // are intentionally read inside the effect to avoid refetch loops.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountId, token, dispatch])

  return null
}
